import React from "react";
import {
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
} from "@chakra-ui/react";
import colors from "../../utils/colors";

interface IProps {
  popoverTrigger: JSX.Element;
  children: JSX.Element;
}
const PopoverCmp = ({ popoverTrigger, children }: IProps) => {
  return (
    <Popover placement="bottom-start">
      <PopoverTrigger>{popoverTrigger}</PopoverTrigger>
      <PopoverContent
        borderWidth={`1px solid ${colors.grey}`}
        boxShadow= {"11px 24px 32px 0px #0000001A"}
      >
        <PopoverBody>{children}</PopoverBody>
      </PopoverContent>
    </Popover>
  );
};

export default PopoverCmp;
